import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Button, Container, Stack, TextField } from '@mui/material';
import { RouteEnum, useSession, VerificationPayload } from 'App';
import { AuthErrorBox } from '@shared';

const validationSchema = yup.object({
  code: yup
    .string()
    .matches(/^\d+$/, 'The code contains only numbers')
    .min(6, 'The code should be of minimum 6 characters length')
    .required('Please enter the code here'),
});

export function Verification() {
  const navigate = useNavigate();

  const [serverErrorMessage, setServerErrorMessage] = useState('');
  const { verification, isCredsEntered, logout } = useSession();
  const { values, touched, errors, handleChange, handleSubmit } = useFormik<VerificationPayload>({
    initialValues: {
      code: '',
    },
    validationSchema,
    onSubmit: async (code) => {
      const response = await verification(code);
      response && setServerErrorMessage(response);
    },
  });
  useEffect(() => {
    if (!isCredsEntered) {
      navigate(RouteEnum.Login);
    }
  }, [navigate, isCredsEntered]);

  return (
    <Container component='article' maxWidth='xs'>
      <AuthErrorBox message={serverErrorMessage} />
      <h2>Two factor authentication</h2>
      <p>We&apos;ve sent you a security code. Please, check your email and input the code here</p>
      <Stack component='form' onSubmit={handleSubmit} noValidate gap={2}>
        <TextField
          value={values.code}
          onChange={handleChange}
          error={touched.code && Boolean(errors.code)}
          helperText={touched.code && errors.code}
          required
          fullWidth
          name='code'
          label='Code'
          type='text'
          autoComplete='one-time-code'
        />
        <Button type='submit' fullWidth variant='contained' sx={{ fontSize: 16 }}>
          Verify
        </Button>
        <Button onClick={logout} fullWidth variant='outlined' sx={{ fontSize: 16 }}>
          Back to login
        </Button>
      </Stack>
    </Container>
  );
}
